export default __webpack_public_path__ + "static/media/central_andes_1_3.2ca97dfc.JPG";